import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 95%;
    float: left;
    
    margin-bottom: 25px;
`;